module.exports = __webpack_public_path__ + "img/icona_menu.c605bef5.png";